import { z } from 'zod';
import { defineEndpoint } from '../define';
import { PollAnswerSchema, PollResponseSchema } from './shapes';

export const RespondToPollBodySchema = z.object({
  answers: z.array(PollAnswerSchema).max(200),
});
export type RespondToPollBody = z.input<typeof RespondToPollBodySchema>;

export const respondToPoll = defineEndpoint({
  method: 'PUT',
  path: '/v1/polls/:pollId/response',
  params: z.object({ pollId: z.string().uuid() }),
  query: z.object({}),
  body: RespondToPollBodySchema,
  response: z.object({ data: PollResponseSchema }),
});

export const retractPollResponse = defineEndpoint({
  method: 'DELETE',
  path: '/v1/polls/:pollId/response',
  params: z.object({ pollId: z.string().uuid() }),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({}),
  successStatus: 204,
});
